export class FlujoTrabajo {
  constructor(
    public id?: string,
    public descripcion?: string,
    public cantidad?: number,
    public estados: any[] = [] 
  ) {
  }
}